export const locale = {
  lang: "it",
  data: {
    MENU: {
      ASSET_CATEGORIES: "Categorie",
    },
    ALERT: {
      CONFIRM_DISSOCIATE_ASSET: "Sei sicuro di voler dissociare l'Asset?",
      CONFIRM_ASSOCIATE_ASSET: "Sei sicuro di voler associare l'Asset?",
      ERROR_DISSOCIATE_ASSET: "Errore nella dissociazione dell'asset.",
      SUCCESS_DISSOCIATE_ASSET: "Asset dissociato con successo.",
      ERROR_ASSOCIATE_ASSET: "Errore nell'associazione dell'asset.",
      ASSET_IN_MAINTENANCE: "Asset momentaneamente in manutenzione.",
      SUCCESS_ASSOCIATE_ASSET: "Asset associato con successo.",
      ERROR_ASSOCIATE_MAINTENANCE: "Errore nell'aggiunta della manutenzione.",
      SUCCESS_ADD_MAINTENANCE: "Manutenzione aggiunta con successo.",
      SUCCESS_ADD_ASSET_CATEGORY: "Categoria di asset aggiunta correttamente.",
      ERROR_ADD_ASSET_CATEGORY: "Errore nell'aggiunta della categoria.",
      SUCCESS_EDIT_ASSET_CATEGORY: "Categoria di asset modificata correttamente.",
      ERROR_EDIT_ASSET_CATEGORY: "Errore nella modifica della categoria asset",
      ERROR_ASSET_CATEGORY_REMOVE: "Errore nell'eliminazione della categoria asset.",
      SUCCESS_UPLOAD_ASSET: "Asset aggiunto correttamente.",
      ERROR_UPLOAD_ASSET: "Errore nell'aggiunta dell'asset.",
      SUCCESS_EDIT_ASSET: "Asset modificato correttamente.",
      ERROR_EDIT_ASSET: "Errore nella modifica dell'asset.",
    },
    IMPORT_ASSETS: "Importa assets",
    YOU_HAVE_NO_ASSET: "Non hai nessun asset aziendale",
    MY_ASSETS: "I miei assets",
    ASSETS_LIST: "Lista degli assets",
    ADD_ASSET: "Aggiungi asset",
    EDIT_ASSET: "Modifica asset",

    ASSETS: "Assets",
    IMPORT: "Importa",
    END_LICENSE: "Scadenza licenza",
    AUTOMATIC_RENEWAL: "Rinnovo automatico",
  },
};
